import 'pixi-spine'

import { start } from 'automaton/Machina'
import Game from 'core/game'
import { gsap } from 'gsap'
import { PixiPlugin } from 'gsap/PixiPlugin'
import popupS from 'popups'
import { signal } from 'services/SignalsService'
import ErrorListener from 'utils/ErrorListener'

gsap.registerPlugin(PixiPlugin)

PixiPlugin.registerPIXI(PIXI)

const errorListener = new ErrorListener()
errorListener.startListening()
if (PIXI.utils.isWebGLSupported()) {
  window.PIXI = PIXI
  window.game = new Game()
  signal.dispatch('INIT:GAME')
  start()
}
else {
  const errorListener = new ErrorListener()
  errorListener.startListening()
  if (PIXI.utils.isWebGLSupported()) {
    window.PIXI = PIXI
    window.game = new Game()
    signal.dispatch('INIT:GAME')
    start()
  }
  else {
    popupS.alert({ content: 'Please TurnON hardware acceleration in browser System settings' })
  }
  popupS.alert({ content: 'Please TurnON hardware acceleration in browser System settings' })
}
